"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBarHeight = void 0;
var _checkoutUtils = require("@ori/checkout-utils");
var _react = require("react");
var _useStoredState = require("./useStoredState");
const useBarHeight = key => {
  const isResizing = (0, _react.useRef)(false);
  const [height, setHeight] = (0, _useStoredState.useStoredState)(key, 300);
  (0, _checkoutUtils.useWindowEvent)('mousemove', (0, _react.useCallback)(e => {
    if (!isResizing.current) {
      return;
    }
    const me = e;
    const newHeight = window.innerHeight - me.clientY;
    const heightLimit = window.innerHeight - 200;
    setHeight(Math.max(100, Math.min(newHeight, heightLimit)));
    document.getSelection()?.empty();
    e.stopPropagation();
    e.preventDefault();
  }, [setHeight]));
  (0, _checkoutUtils.useWindowEvent)('mouseup', (0, _react.useCallback)(() => {
    isResizing.current = false;
  }, []));
  (0, _checkoutUtils.useWindowEvent)('resize', (0, _react.useCallback)(() => {
    if (height > window.innerHeight) {
      setHeight(300);
    }
  }, [height, setHeight]));
  (0, _react.useEffect)(() => {
    if (height > window.innerHeight) {
      setHeight(300);
    }
  }, [height, setHeight]);
  return [height, (0, _react.useCallback)(() => isResizing.current = true, [])];
};
exports.useBarHeight = useBarHeight;